import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import api_call from '../../globals/common_utilities/axios_old';
import CONSTANTS from '../../globals/common_utilities/constant';

const initialState = {
	loading: false,
	Response: [],
	error: '',
};

export const Redux_addInstructor = createAsyncThunk(
	'addInstructor/Redux_addInstructor',
	({ token, body }) => {
		console.log('body--------->>', token, body);
		return api_call(
			CONSTANTS.API_METHODS.POST,
			'https://azuq6zfu0l.execute-api.ap-south-1.amazonaws.com/dev/api/v1/users',
			{ flag: true },
			{},
			body
		);
	}
);

const addInstructor = createSlice({
	name: 'addInstructor',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(Redux_addInstructor.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(Redux_addInstructor.fulfilled, (state, action) => {
			state.loading = false;
			state.Response = action.payload;
			state.error = '';
		});
		builder.addCase(Redux_addInstructor.rejected, (state, action) => {
			state.loading = false;
			state.Response = [];
			state.error = action.error.message;
		});
	},
});

export default addInstructor.reducer;
